import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {MatTooltipModule, TooltipPosition} from '@angular/material/tooltip';

/**
 * Small help icon ("?") that reveals more information in a tooltip on hover.
 * Replaces inline hint texts so forms stay light. Pass the already-translated
 * tooltip text via `[text]` (e.g. `[text]="'SOME.KEY' | translate"`).
 */
@Component({
  selector: 'app-help-icon',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-icon.component.scss'],
})
export class HelpIconComponent {
  /** Tooltip content, already translated. When empty, nothing is rendered. */
  text = input<string>();
  /** Material icon name; defaults to the outlined help glyph. */
  icon = input<string>('help_outline');
  position = input<TooltipPosition>('above');
}
